import dayjs from 'dayjs';
import { Badge, Tooltip } from 'design-system';
import { getInvoiceChipKind, INVOICE_CHIP_META } from 'pages/reconciliation/utils/invoices';

export interface IInvoiceStatusChip {
  commission: number | null;
  invoice: { isPaid: boolean; paidAt?: string | null; paidNote: string | null } | null;
}

/** Paid (green) / Unpaid (amber) / Pending terms / No invoice — the paid chip's tooltip carries
 * the payment date + free-text note; the two gray states explain themselves via static tooltips. */
export const InvoiceStatusChip = ({ commission, invoice }: IInvoiceStatusChip) => {
  const kind = getInvoiceChipKind({ commission, invoice });
  const meta = INVOICE_CHIP_META[kind];

  const paidTooltip =
    kind === 'paid'
      ? ['Paid', invoice?.paidAt ? dayjs(invoice.paidAt).format('DD MMM YYYY') : null, invoice?.paidNote]
          .filter(Boolean)
          .join(' · ')
      : null;
  const tooltip = paidTooltip ?? meta.tooltip;

  return (
    <Tooltip label={tooltip} placement='top' hasArrow isDisabled={!tooltip}>
      <Badge
        px='sm'
        py='xs'
        borderRadius='md'
        fontSize='xs'
        fontWeight='semibold'
        textTransform='none'
        whiteSpace='nowrap'
        color={meta.color}
        bg={meta.bg}>
        {meta.label}
      </Badge>
    </Tooltip>
  );
};
